import { lazy, Suspense } from "react";
import { DashboardApp } from "./components/DashboardApp";
import { ThemeProvider } from "./lib/theme";

const LandingPage = lazy(async () => {
  const module = await import("./components/LandingPage");
  return { default: module.LandingPage };
});

function AppRoutes() {
  const pathname = window.location.pathname;

  if (pathname === "/dashboard") {
    return <DashboardApp />;
  }

  return (
    <Suspense
      fallback={
        <div className="flex min-h-screen items-center justify-center bg-background text-sm text-muted-foreground">
          Loading TrackInsiders…
        </div>
      }
    >
      <LandingPage />
    </Suspense>
  );
}

/** Mounts the shared theme owner above public and authenticated routes. */
export default function App() {
  return (
    <ThemeProvider>
      <AppRoutes />
    </ThemeProvider>
  );
}
